import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, NavigationBehaviorOptions, RedirectCommand, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { RolesService } from 'shared/services/roles.service';
import { AuthGuard } from './auth.guard';
import { BISACONSTANTS } from 'app/modules/bisa/bisa-constants';

export const ResourceRedirectGuard = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | RedirectCommand> => {
    const _rolesService = inject(RolesService);
    const _router = inject(Router);
    const resourceAcl = {
        resource: route.data.aclResource,
        accessLevel: route.data.aclAccessLevel,
        userType: route.data.aclUserType,
    };

    return (AuthGuard(route, state) as Observable<boolean | RedirectCommand>).pipe(
        switchMap(authResult => {
            if (!authResult) {
                _router.navigate([BISACONSTANTS.bisaLogin], { queryParams: { redirect: route.routeConfig.path } });
                return of(false);
            }
            return _rolesService.hasResourceAccess([resourceAcl]);
        }),
        tap(result => {
            if (!result) {
                _router.navigateByUrl('/unauthorized');
            }
        })
    );
};
